<template>
		<div class="root">
				<div class="hh-profile-container campaign-edit-container" ref="top">
						<Alert
								v-if="notification.message"
								:message="notification.message"
								:type="notification.type"
								@hideAlert="hideAlert"
								ref="top"
						/>
						<div class="row" :class="notification.message ? 'margin-top-30' : ''">
								<div class="col-md-4 edit-wrapper">
										<ul class="left-menu">
											<li v-for="campaignComponent in campaignComponents" :class="activeComponent.name === campaignComponent.name ? 'active' : ''">
												<a href="" class="edit_section without-decoration" @click.prevent="setActiveComponent(campaignComponent)">
													{{campaignComponent.title}}
													<img alt="Edit" src="/dist/site/static/icons/edit.svg" class="edit-icon" :style="[ (activeComponent.name === campaignComponent.name) ? {'display' : 'flex'} : {'display' : 'none'}]">		
												</a>
											</li>	
										</ul>
										<div class="margin-top-20 margin-bottom-30 width-60 m-auto">
												<a :href="`/campaign/${campaignSlug}`" class="btn hh-btn width-100 view-btn">View Campaign</a>
										</div>
								</div>
								<div class="col-md-8">
										<div class="panel panel-default campaign-wrapper padding-bottom-10 margin-left-0 margin-right-0 padding-top-0">
												<div class="row">
													<div class="col-xs-12 margin-top-30 padding-left-xs-30">
														<h3 class="text-left text-normal">
															{{formTitle}}
														</h3>
													</div>
												</div>
												<div v-if="isLoading" class="section-body margin-top-50 margin-bottom-50">
														<loading-animation/>
												</div>

												<div class="section-body" v-show="!isLoading" v-if="dataAnalysed">
														<div class="row margin-top-20">
																<div class="col-sm-12">
																		<div class="campaign-information-section" ref="campaignInformation"
																		     v-if="activeComponent.name === campaignComponents.campaignInformation.name">
																				<campaign-information
																						@componentLoading="componentLoading"
																						@formSubmitted="formSubmitted"
																						:campaign-data="campaignData"
                                            :campaignImages="campaignImages"
																						:static-data="staticData"
																						:show-title="false"
																						:show-skip-button="false"
																						:show-save-as-draft="false"
																						:edit-mode="true"
																				/>
																		</div>

																		<div class="campaign-suggested-donation-amounts-section"
																		     ref="campaignSuggestedDonationAmounts"
																		     v-if="activeComponent.name === campaignComponents.campaignSuggestedDonationAmounts.name">
																				<campaign-suggested-donation-amounts
																						@componentLoading="componentLoading"
																						@formSubmitted="formSubmitted"
																						:campaign-data="campaignData"
																						:static-data="staticData"
																						:show-title="false"
																						:show-skip-button="false"
																						:show-save-as-draft="false"
																						:edit-mode="true"
																				/>
																		</div>
																		<div class="campaign-social-links" ref="campaignSocialLinks"
																		     v-if="activeComponent.name === campaignComponents.campaignSocialLinks.name">
																				<campaign-social-links
																						@componentLoading="componentLoading"
																						@formSubmitted="formSubmitted"
																						:campaign-data="campaignData"
																						:static-data="staticData"
																						:show-title="false"
																						:show-skip-button="false"
																						:show-save-as-draft="false"
																						next-button-text="Save changes"
																						:edit-mode="true"
																				/>
																		</div>
																		<div class="campaign-payout-information" ref="campaignPayoutInformation"
																		     v-if="activeComponent.name === campaignComponents.campaignPayoutInformation.name">
																				<campaign-payout-information
																						@componentLoading="componentLoading"
																						@formSubmitted="formSubmitted"
																						:campaign-slug="campaignSlug"
																						:campaign-data="campaignData"
																						:user-data="userData"
																						:payouts-data="payoutsData"
																						:static-data="staticData"
																				/>
																		</div>
																</div>
														</div>
												</div>
										</div>
								</div>
						</div>
				</div>
		</div>

</template>

<script>
	import {mapActions, mapGetters} from 'vuex'

	import Alert from '../../components/form/elements/Alert'
	import LoadingAnimation from '../../components/LoadingAnimation'
	import CampaignInformation from '../../components/campaign/CampaignInformation'
	import CampaignDetails from '../../components/campaign/CampaignDetails'
	import CampaignSuggestedDonationAmounts from '../../components/campaign/CampaignSuggestedDonationAmounts'
	import CampaignSocialLinks from '../../components/campaign/CampaignSocialLinks'
	import CampaignPayoutInformation from '../../components/campaign/CampaignPayoutInformation'

	export default {
		name: 'EditCampaignView',

		components: {
			CampaignPayoutInformation,
			CampaignInformation,
			CampaignDetails,
			CampaignSuggestedDonationAmounts,
			CampaignSocialLinks,
			Alert,
			LoadingAnimation,
		},

		props: {},

		beforeMount() {
			if (!_.isEmpty(this.$route.params.slug)) {
				this.campaignSlug = this.$route.params.slug
			}

			if (!this.isDataFetched) {
				this.fetchData(this.campaignSlug).then(() => {
					this.forceRecompute++
					this.analyseData()
				})
			} else {
				this.analyseData()
			}

			this.activeComponent = this.campaignComponents.campaignInformation

			if (!_.isEmpty(this.alert)) {
				this.notification = this.alert
				this.$store.commit('setAlert', null)
			}
		},

		mounted() {
			this.loading = false
		},

		data: () => {
			return {
				campaignSlug: null,
				loading: true,
				dataAnalysed: false,
				showAlert: false,
				forceRecompute: 0,
				notification: {
					message: null,
					type: null,
				},
				componentsLoadingStatus: {
					campaignComponent: true,
				},
				campaignComponents: {
					campaignInformation: {
						name: 'campaign-information',
						title: 'Edit Campaign Information'
					},
					campaignSuggestedDonationAmounts: {
						name: 'campaign-suggested-donation-amounts',
						title: 'Suggested Donation Amounts',
					},
					campaignSocialLinks: {
						name: 'campaign-social-links',
						title: 'Social Links',
					},
					campaignPayoutInformation: {
						name: 'campaign-payout-information',
						title: 'Donations Account / Early Payout',
					},
				},
				activeComponent: {
					name: null,
					title: null,
				},
				campaignData: {},
				campaignImages: {},
				staticData: {},
				userData: {
					business_name: null,
					name: null,
					date_of_birth: null,
					identification_number: null,
					account_number: null,
					routing_number: null,
					available_to_pay_out: null,
					status_label: null,
					state: {},
					first_name: null,
        	last_name: null
				},
				payoutsData: {
					payoutsData: null,
					data: {},
				},
			}
		},

		methods: {
			...mapActions('campaign', ['fetchData']),

			analyseData() {
				this.dataAnalysed = false
				this.loading = true

				if (this.isDataFetched) {
					this.fillCampaignData()
					this.fillPayoutsData()
					this.fillUserData()
					this.fillCampaignImages()
					this.fillStaticData()

					this.dataAnalysed = true
					this.loading = false
				} else {
					return false
				}
			},

			fillCampaignData() {
				if (!_.isEmpty(this.fetchedData.data.attributes)) {
					this.campaignData = {...this.campaignData, ...this.fetchedData.data.attributes}
				}
			},

			fillCampaignImages() {
				if (!_.isEmpty(this.fetchedData.data.relations.campaignImages)) {
					this.campaignImages = {...this.fetchedData.data.relations.campaignImages}
				}
			},

			fillStaticData() {
				if (!_.isEmpty(this.fetchedData.data.staticData)) {
					this.staticData = {...this.staticData, ...this.fetchedData.data.staticData}
				}
			},

			fillUserData() {
				if (!_.isEmpty(this.fetchedData.data.relations.userData)) {
					this.userData = {...this.userData, ...this.fetchedData.data.relations.userData}
				}
			},

			fillPayoutsData() {
				if (!_.isEmpty(this.fetchedData.data.relations.payoutsData)) {
					this.payoutsData = {...this.payoutsData, ...this.fetchedData.data.relations.payoutsData}
				}
			},


			componentLoading(componentName, value) {
				this.componentsLoadingStatus[componentName] = value
			},

			formSubmitted(alertData = null) {
				this.loading = true
				this.dataAnalysed = false
				this.fetchData(this.campaignSlug).then(() => {
					if (_.isEmpty(alertData)) {
						this.notification.message =  `Campaign updated.`
						this.notification.type = 'bg-success'
					} else {
						this.notification = {...alertData}
					}
					this.forceRecompute++
					this.analyseData()
				})
			},

			setActiveComponent(component) {
				this.componentsLoadingStatus.campaignComponent = true
				this.activeComponent = { ...component }
			},

			hideAlert() {
				this.notification = {
					message: null,
						type: null,
				}
			},

			imagesUpdated(images) {
				this.campaignImages = { ...images }
			},
		},

		computed: {
			...mapGetters(['alert']),

			fetchedData: {
				get() {
					return this.$store.getters['campaign/campaignData'](this.campaignSlug, this.forceRecompute)
				},
			},

			formTitle() {
				if (this.isLoading) {
					return 'Loading...'
				}

				if (_.isEmpty(this.activeComponent.title)) {
					return 'Edit Campaign'
				}

				return this.activeComponent.title
			},

			isDataFetched() {
				return !_.isEmpty(this.fetchedData)
			},

			isLoading() {
				for (let component in this.componentsLoadingStatus) {
					if (this.componentsLoadingStatus[component]) {
						return true
					}
				}

				return this.loading
			},
		},
	}
</script>

<style lang="scss" scoped>
		.root::v-deep {
				@import '../../../style/pages/profile';
				@import '../../../style/pages/campaign';
		}

		@media screen and (max-width: 1000px) {
			.panel-default {
				box-shadow: none !important;
			}

			.col-md-8 {
				background: white;
			}

			.campaign-edit-container ul.left-menu li a {
				font-size: 15px !important;
			}

			.campaign-edit-container .campaign-wrapper {
				padding: 0 !important;
			}
		}

		.panel {
			padding: 0px 58px; 
		}

		.edit-icon {
			margin-left: auto;  
			margin-top: -21px;
		}

		.edit-wrapper {
			background: #FFFFFF;border: 1px solid #EBEBEC;box-sizing: border-box;border-radius: 8px;
		}

		.m-auto {
			margin: auto;
		}

		@media screen and (max-width: 767px) {
			.padding-left-xs-30 {
				padding-left: 30px;
			}
		}
		

		.view-btn {
			background: #FFFFFF; height: 34px; padding: 10px;
			border: 1px solid #1780EE;
			box-sizing: border-box;
			border-radius: 8px; 
			color: #1780EE;  
			font-family: Circular Std;
			font-style: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 12px;
			text-align: center;
			color: #1780EE;
		}

		h3 {
			font-family: Circular Std;font-style: normal;font-weight: bold;font-size: 26px !important; line-height: 33px !important;letter-spacing: -0.01em;color: #000000;
		}
		
</style>